import React from 'react';

import { User } from '../data';

interface AppUserContext {
  user: User | null;
  reloadUser: () => void;
}

export const UserContext = React.createContext<AppUserContext | null>(null);

const UserProvider: React.FC<React.PropsWithChildren<AppUserContext>> = ({
  user: initialUser,
  reloadUser,
  children,
}) => {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <UserContext.Provider value={{ user: initialUser, reloadUser }}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used under UserProvider');
  }
  return context;
};

export default UserProvider;
